import React from 'react';
import './ByzzerPortfolioCard.scss';
import { TrackClick } from '@/analytics';
import ByzzerLink from './ByzzerLink';
import useCanRunReport from '@/hooks/useCanRunReport';
import { useUser } from '@/contexts/UserContext';
import { alert as byzzerAlert } from "@/components/form";

type ByzzerPortfolioCardProps = {
    title: string;
    className?: string;
    subtitle: string;
    subtitleHighlight: string;
    isLink?: boolean;
    children?: React.ReactNode;
    sku?: string;
};

const baseClassName = 'byzzer-portfolio-card';

// todo: See if there's a better name for this component
export const ByzzerPortfolioCard = ({title, className, subtitle, subtitleHighlight, isLink = true, children, sku}: ByzzerPortfolioCardProps) => {

    const validateReportCountAndShow = useCanRunReport({baseClassName});
    const {subscribedSkus} = useUser();

    const handleSubtitleClick = (sku: string) => {
        if (sku && subscribedSkus.includes(sku)) {
            validateReportCountAndShow({ reportType: 'subscription', sku});
        } else {
            byzzerAlert({
                content: <p>Please reach out to your Byzzer sales representative</p>,
            });
        }
    };

    return (
        <div className={`byzzer-card ${className}`}>
            <div className="byzzer-card__title">{title}</div>
            {isLink ? (
                <div className="byzzer-card__subtitle">
                    {subtitle}
                    <TrackClick name={`ByzzerPortfolioCard - ${title} - Clicked Subtitle Link`}>
                        <ByzzerLink
                            className="byzzer-card__subtitle-link"
                            label={subtitleHighlight}
                            onClick={() => {
                                handleSubtitleClick(sku!);
                            }}
                        />
                    </TrackClick>
                </div>
            ) : (
                <div className="byzzer-card__subtitle">
                    {subtitle}
                    <span className="byzzer-card__subtitle-highlight">{subtitleHighlight}</span>
                </div>
            )}
            <div className="byzzer-card__content">{children}</div>
        </div>
    );
}
export default ByzzerPortfolioCard;
